import * as AsyncLock from "async-lock";
import axios, {
    AxiosRequestConfig,
    AxiosResponse,
    CancelTokenStatic,
    CancelTokenSource
} from "axios";

import { AuthVerified } from "./../models/generic/auth-transfer";
import {
    APICONFIG_HEADER_AUTHORIZATION,
    LOCALSTORAGE_USERSSION,
    // APICONFIG_HEADER_LANGUAGE,
    LOCALSTORAGE_AUTH2,
    APICONFIG_HEADER_SESSIONID,
    WEBAPP_LAYOUT,
    SERVICE_LINKS,
    LOCALSTORAGE_AUTH
} from "./../common/constants";

import { ApiResponse } from "../models/app-configuration";
import serverErrorCodeConstant from "../common/server-error-code.constant";
import VueI18n from "vue-i18n";
import {
    Oauthorization2Response, Oauth2Data,
} from "./authorization/data-model";
import {
    LocalStoredOAuthorization2Response
} from "./authorization/authorizationFactory";
import { LocalforageWrapper } from "./localforage-wrapper";

import store from "../store";


export interface IAxiosConfigurationHelper {
    axiosRequestHandler(config: AxiosRequestConfig, i18n: VueI18n);
    axiosResponseHandler(config: AxiosResponse);
    axiosValidResponseHandler(config: AxiosRequestConfig);
    axiosInternalExceptionResponseHandler(config: AxiosResponse);
    axiosNotFoundResponseHandler(config: AxiosResponse);
    axiosUnauthorizedResponseHandler(config: AxiosRequestConfig);
    axiosExceptionHandler(error: any, a);
}

let isRefreshing = false;
let refreshSubscribers = [];
export class AxiosConfigurationHelper implements IAxiosConfigurationHelper {
    refreshTokenLocker = new AsyncLock({
        maxPending: 100 * 100 * 100
    });
    refreshTokenBusy = false;
    dtCancelToken: CancelTokenStatic;
    dtCancelTokenSource: CancelTokenSource;
    numberOfFailure: number;
    serviceAvailable: boolean | null = null;
    serviceUnavailable: number;
    sessionExpired: number;

    //counter = 0;

    constructor() {
        this.numberOfFailure = 0;
        this.dtCancelToken = axios.CancelToken;
        this.dtCancelTokenSource = this.dtCancelToken.source();
        this.serviceUnavailable = 0;
        this.sessionExpired = 0;
    }
    axiosHandleValidStatus(status: number) {
        return status >= 200 && status <= 504;
    }

    private clearAuthDataStorage() {
        localStorage.removeItem("auth");
        localStorage.removeItem("AuthorizationData");
        localStorage.removeItem("userssion");
        LocalforageWrapper.clear();
    }

    private gotoLogin() {
        console.log(store)
        const webappLayout = store.state.common.webappLayoutMode;
        if (webappLayout === WEBAPP_LAYOUT.DEFAULT) {
            const authSettings = JSON.parse(
                localStorage.getItem("AuthorizationSettingData")
            );

            const loginUrlEl = document.querySelector(
                "meta[name='Login-Url']"
            );

            if (loginUrlEl) {
                location.href = loginUrlEl.getAttribute("content");
            } else {
                location.href = authSettings.LoginUrl;
            }
        }


    }
    axiosResponseHandler(response: AxiosResponse) {
        if (this.serviceAvailable === null) this.serviceAvailable = true;

        // Skip all interceptor handling if skipRetry flag is set - return server response directly
        const requestConfig = response.config as any;
        if (requestConfig?.skipRetry && response.status >= 400) {
            // Keep original server response data (including errors array)
            response.data = new ApiResponse({
                isSuccess: false,
                data: response.data,  // Contains { errors: [{ Code: "..." }] }
                code: response.status,
                message: response.statusText
            });
            return response;
        }

        switch (response.status) {
            case 200:
            case 201:
            case 204:
                //this.counter++;
                response.data = new ApiResponse(
                    { isSuccess: true, data: response.data },
                    response.headers
                );
                break;
            //if (this.counter < 30) break;
            case 400:
                if (response.data.code == serverErrorCodeConstant.ValidationException) {
                    response.data = new ApiResponse({
                        isSuccess: false,
                        data: response.data,
                        code: response.status,
                        message: response.statusText
                    });
                }
                break;
            case 401:
                const originalRequest = response.config as any;
                const currentUserSession = localStorage.getItem(LOCALSTORAGE_USERSSION);
                const userSession: AuthVerified = JSON.parse(currentUserSession);
                if (!userSession.RefreshToken) return;
                console.log(isRefreshing, currentUserSession, originalRequest, userSession);

                if (!isRefreshing) {
                    isRefreshing = true;
                    this.refreshAccessToken()
                        .then((newToken: AxiosResponse) => {
                            if (newToken.data.error || newToken.status !== 200) {
                                this.clearAuthDataStorage();
                                this.gotoLogin();
                                return;
                            }

                            console.log("received new token:" + JSON.stringify(newToken));

                            // UPDATE CURRENT REQUEST
                            axios.defaults.headers.common[APICONFIG_HEADER_AUTHORIZATION] = "Bearer " + newToken.data.AccessToken;
                            //todo (huyngo): will refresh SessionId if improve reset value when refresh-token
                            //axios.defaults.headers.common[APICONFIG_HEADER_SESSIONID] = newToken.data.Data.SessionId;

                            const now = new Date();
                            newToken['accessTokenExpiration'] = new Date(now.getTime() + ((parseInt((newToken as any).data.expiresIn) - 60) * 1000));
                            newToken.data['accessTokenExpiration'] = new Date(now.getTime() + ((parseInt((newToken as any).data.expiresIn) - 60) * 1000));
                            newToken.data.data['accessTokenExpiration'] = new Date(now.getTime() + ((parseInt((newToken as any).data.expiresIn) - 60) * 1000));

                            // STORED USER SESSION
                            userSession.Token = newToken.data.accessToken;
                            userSession.RefreshToken = newToken.data.refreshToken;

                            //todo (huyngo): will refresh SessionId if improve reset value when refresh-token
                            //userSession.SessionId = newToken.data.Data.SessionId;

                            localStorage.setItem(LOCALSTORAGE_USERSSION, JSON.stringify(userSession));

                            // STORED OAUTH2
                            // NOTE: REFRESH TOKEN ONLY SUPPORT FOR OAUTH2
                            const auth2Json = localStorage.getItem(LOCALSTORAGE_AUTH2);
                            if (auth2Json != null) {
                                let auth2: Oauthorization2Response = JSON.parse(auth2Json);
                                auth2.oauth2 = newToken.data as any;
                                auth2.data.oauth2 = newToken.data as any;
                                localStorage.setItem(
                                    LOCALSTORAGE_AUTH2,
                                    JSON.stringify(auth2)
                                );
                            }

                            const authJson = localStorage.getItem(LOCALSTORAGE_AUTH);
                            if (authJson != null) {
                                let auth: any = JSON.parse(authJson);
                                auth.token = newToken.data.accessToken;
                                localStorage.setItem(LOCALSTORAGE_AUTH, JSON.stringify(auth));
                            }

                            //this.counter = 0;
                            this.onRefreshed(newToken.data.accessToken);
                        })
                        .catch(error => {
                            this.clearAuthDataStorage();
                            this.gotoLogin();
                        });
                }

                return new Promise<AxiosResponse>((resolve, reject) => {
                    this.subscribeTokenRefresh(token => {
                        console.log('Retrying request with new token');
                        originalRequest.headers["Authorization"] = "Bearer " + token;
                        
                        resolve(axios(originalRequest));
                    });
                }).catch(error => {
                    console.error('Token refresh failed:', error);
                    throw error;
                });

            case 404:
                response.data = new ApiResponse({
                    isSuccess: false,
                    data: null,
                    code: response.status,
                    message: response.statusText
                });
                break;
            case 500:
                response.data = new ApiResponse({
                    isSuccess: false,
                    data: response.data,
                    code: response.data.code, //1000
                    message: response.data.msg //
                });
                break;
            case 501:
            case 502:
            case 503:
                this.serviceUnavailable++;
                break;
            default:
                break;
        }
        return response;
    }

    axiosExceptionHandler(error: any) {
        if (error.config.url.indexOf("/files/upload") >= 0) {
            //todo if failed upload Picture,Document
        } else {
            this.serviceUnavailable++;
            if (this.serviceAvailable === null) this.serviceAvailable = true;
            return Promise.reject(error);
        }
    }
    axiosRequestHandler(config: AxiosRequestConfig, i18n: VueI18n) {
        // get auth2 from local store
        // update to request config
        let auth2 = new LocalStoredOAuthorization2Response();
        let auth2Data = auth2.authorizationData as Oauth2Data;
        if (auth2Data) {
            config.headers.common[APICONFIG_HEADER_AUTHORIZATION] =
                "Bearer " + auth2Data.oauth2.accessToken;
        }
        return this.refreshTokenLocker.acquire(
            AxiosConfigurationHelper.name,
            async done => {
                if (this.numberOfFailure !== 0) {
                    config.cancelToken = this.dtCancelTokenSource.token;
                    this.dtCancelTokenSource.cancel("Sessions expired");
                    this.numberOfFailure = 0;
                }
                done(null, config);
            }
        );
    }
    axiosValidResponseHandler(response: AxiosResponse) {
        return response;
    }
    axiosInternalExceptionResponseHandler(response: AxiosResponse) {
        return response;
    }
    axiosNotFoundResponseHandler(response: AxiosResponse) {
        return response;
    }
    axiosUnauthorizedResponseHandler(response: AxiosResponse): ApiResponse {
        return new ApiResponse({
            isSuccess: false,
            code: response.data.Code,
            message: response.data.Details
        });
    }

    refreshAccessToken(): Promise<any> {
        // const currentAuthorizationConfig = localStorage.getItem(LOCALSTORAGE_AUTH);
        const currentUserSession = localStorage.getItem(LOCALSTORAGE_USERSSION);
        const userSession: AuthVerified = JSON.parse(currentUserSession);
        // const config: AuthTransfer = JSON.parse(currentAuthorizationConfig);
        const instance = axios.create({
            //baseURL: config.authApiEndPoint,
            baseURL: SERVICE_LINKS.AUTH_URL,
            headers: {
                [APICONFIG_HEADER_AUTHORIZATION]: "Bearer " + userSession.Token,
                [APICONFIG_HEADER_SESSIONID]: userSession.SessionId || ''
            }
        });
        console.log("start refresh token:" + JSON.stringify(userSession));
        return instance.get<{ [key: string]: any }>(
            `/auth/web/refresh/${userSession.RefreshToken}`
        );
    }
    subscribeTokenRefresh(cb) {
        refreshSubscribers.push(cb);
    }

    onRefreshed(token) {
        while (true) {
            const cb = refreshSubscribers.pop();
            if (cb == null) {
                isRefreshing = false;
                //this.counter = 0;
                return;
            }
            cb(token);
        }
    }
}
